import { render, staticRenderFns } from "./ForumActivity.vue?vue&type=template&id=4d983ef8&"
import script from "./ForumActivity.vue?vue&type=script&lang=js&"
export * from "./ForumActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports